export const BASE_URL = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_API_URL
  : 'http://localhost:8000/api';

console.log(BASE_URL, 'api base url')

  // export const BASE_URL = 'https://portal.baltichome.pl/api';
  // export const BASE_URL = 'https://portal.clvr.pl/api';